var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 54,
    viewBox: "0 0 155 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2016_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 50.6201C5.5 49.1013 4.26878 47.8701 2.75 47.8701C1.23122 47.8701 -1.86594e-07 49.1013 -1.20206e-07 50.6201C-5.38182e-08 52.1389 1.23122 53.3701 2.75 53.3701C4.26878 53.3701 5.5 52.1389 5.5 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 26.6802C5.5 25.1614 4.26878 23.9302 2.75 23.9302C1.23122 23.9302 -1.86594e-07 25.1614 -1.20206e-07 26.6802C-5.38182e-08 28.199 1.23122 29.4302 2.75 29.4302C4.26878 29.4302 5.5 28.199 5.5 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.75C5.5 1.23122 4.26878 -1.86594e-07 2.75 -1.20206e-07C1.23122 -5.38182e-08 -1.86594e-07 1.23122 -1.20206e-07 2.75C-5.38182e-08 4.26878 1.23122 5.5 2.75 5.5C4.26878 5.5 5.5 4.26878 5.5 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.99 47.8604C25.51 47.8604 26.74 49.0904 26.74 50.6104C26.74 52.1304 25.51 53.3604 23.99 53.3604C22.47 53.3604 21.24 52.1304 21.24 50.6104C21.24 49.0904 22.47 47.8604 23.99 47.8604Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.99 23.9302C25.51 23.9302 26.74 25.1602 26.74 26.6802C26.74 28.2002 25.51 29.4302 23.99 29.4302C22.47 29.4302 21.24 28.2002 21.24 26.6802C21.24 25.1602 22.47 23.9302 23.99 23.9302Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.99 -1.20206e-07C25.51 -1.86648e-07 26.74 1.23 26.74 2.75C26.74 4.27 25.51 5.5 23.99 5.5C22.47 5.5 21.24 4.27 21.24 2.75C21.24 1.23 22.47 -5.3765e-08 23.99 -1.20206e-07Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.98 50.6201C47.98 49.1013 46.7488 47.8701 45.23 47.8701C43.7112 47.8701 42.48 49.1013 42.48 50.6201C42.48 52.1389 43.7112 53.3701 45.23 53.3701C46.7488 53.3701 47.98 52.1389 47.98 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.98 26.6802C47.98 25.1614 46.7488 23.9302 45.23 23.9302C43.7112 23.9302 42.48 25.1614 42.48 26.6802C42.48 28.199 43.7112 29.4302 45.23 29.4302C46.7488 29.4302 47.98 28.199 47.98 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.98 2.75C47.98 1.23122 46.7488 -1.86594e-07 45.23 -1.20206e-07C43.7112 -5.38182e-08 42.48 1.23122 42.48 2.75C42.48 4.26878 43.7112 5.5 45.23 5.5C46.7488 5.5 47.98 4.26878 47.98 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.22 50.6201C69.22 49.1013 67.9888 47.8701 66.47 47.8701C64.9512 47.8701 63.72 49.1013 63.72 50.6201C63.72 52.1389 64.9512 53.3701 66.47 53.3701C67.9888 53.3701 69.22 52.1389 69.22 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.22 26.6802C69.22 25.1614 67.9888 23.9302 66.47 23.9302C64.9512 23.9302 63.72 25.1614 63.72 26.6802C63.72 28.199 64.9512 29.4302 66.47 29.4302C67.9888 29.4302 69.22 28.199 69.22 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.22 2.75C69.22 1.23122 67.9888 -1.86594e-07 66.47 -1.20206e-07C64.9512 -5.38182e-08 63.72 1.23122 63.72 2.75C63.72 4.26878 64.9512 5.5 66.47 5.5C67.9888 5.5 69.22 4.26878 69.22 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46 50.6201C90.46 49.1013 89.2287 47.8701 87.71 47.8701C86.1912 47.8701 84.96 49.1013 84.96 50.6201C84.96 52.1389 86.1912 53.3701 87.71 53.3701C89.2287 53.3701 90.46 52.1389 90.46 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46 26.6802C90.46 25.1614 89.2287 23.9302 87.71 23.9302C86.1912 23.9302 84.96 25.1614 84.96 26.6802C84.96 28.199 86.1912 29.4302 87.71 29.4302C89.2287 29.4302 90.46 28.199 90.46 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46 2.75C90.46 1.23122 89.2287 -1.86594e-07 87.71 -1.20206e-07C86.1912 -5.38182e-08 84.96 1.23122 84.96 2.75C84.96 4.26878 86.1912 5.5 87.71 5.5C89.2287 5.5 90.46 4.26878 90.46 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7 50.6201C111.7 49.1013 110.469 47.8701 108.95 47.8701C107.431 47.8701 106.2 49.1013 106.2 50.6201C106.2 52.1389 107.431 53.3701 108.95 53.3701C110.469 53.3701 111.7 52.1389 111.7 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7 26.6802C111.7 25.1614 110.469 23.9302 108.95 23.9302C107.431 23.9302 106.2 25.1614 106.2 26.6802C106.2 28.199 107.431 29.4302 108.95 29.4302C110.469 29.4302 111.7 28.199 111.7 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7 2.75C111.7 1.23122 110.469 -1.86594e-07 108.95 -1.20206e-07C107.431 -5.38182e-08 106.2 1.23122 106.2 2.75C106.2 4.26878 107.431 5.5 108.95 5.5C110.469 5.5 111.7 4.26878 111.7 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94 50.6201C132.94 49.1013 131.709 47.8701 130.19 47.8701C128.671 47.8701 127.44 49.1013 127.44 50.6201C127.44 52.1389 128.671 53.3701 130.19 53.3701C131.709 53.3701 132.94 52.1389 132.94 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94 26.6802C132.94 25.1614 131.709 23.9302 130.19 23.9302C128.671 23.9302 127.44 25.1614 127.44 26.6802C127.44 28.199 128.671 29.4302 130.19 29.4302C131.709 29.4302 132.94 28.199 132.94 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94 2.75C132.94 1.23122 131.709 -1.86594e-07 130.19 -1.20206e-07C128.671 -5.38182e-08 127.44 1.23122 127.44 2.75C127.44 4.26878 128.671 5.5 130.19 5.5C131.709 5.5 132.94 4.26878 132.94 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18 50.6201C154.18 49.1013 152.949 47.8701 151.43 47.8701C149.911 47.8701 148.68 49.1013 148.68 50.6201C148.68 52.1389 149.911 53.3701 151.43 53.3701C152.949 53.3701 154.18 52.1389 154.18 50.6201Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18 26.6802C154.18 25.1614 152.949 23.9302 151.43 23.9302C149.911 23.9302 148.68 25.1614 148.68 26.6802C148.68 28.199 149.911 29.4302 151.43 29.4302C152.949 29.4302 154.18 28.199 154.18 26.6802Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18 2.75C154.18 1.23122 152.949 -1.86594e-07 151.43 -1.20206e-07C149.911 -5.38182e-08 148.68 1.23122 148.68 2.75C148.68 4.26878 149.911 5.5 151.43 5.5C152.949 5.5 154.18 4.26878 154.18 2.75Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2016_1452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.37,
    height: 154.19,
    fill: "white",
    transform: "translate(0 53.3701) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.00a87b5c4a2314808286f5c5e6c6111f.svg";
export { ForwardRef as ReactComponent };